import { ListType, PagerBase, ResponseBase } from "../..";
import con from "../../../connection";

const path = '/delete-companies';

export type ApiGetDeleteCompanyListResponse = {
    id: number,
    company_code: string,
    company_name: string,
    stoped_date: string,
    limit_date: string,
    created_at: string,
    user_name: string,
    updated_at: string,
    immediate_at: string,
    immediate_user_name: string,
    deleted_at: string,
}

export type ApiGetDeleteCompanyRequest = {
  /** 1の場合、全件表示 */
  is_view?: number,
  /*
   * 0:即時と定期（デフォルト）
   * 1:即時のみ
   * 2:定期のみ
   */
  kind?: number,
  /*
   * 指定無しの場合はデフォルト30件
   */
  limit?: number,
  /** 指定なしの場合はデフォルト1 */
  page?: number,
  /*
   * 1:企業コード
   * 2:利用停止日
   * 3:保存期間終了日
   * 4:データ削除登録日（デフォルト）
   * 5:即時削除登録日
   * 6:削除実施日
   */
  sort_by?: number,
  /**
   * 0:昇順
   * 1:降順（デフォルト）"
   */
  highlow?: number,
}

export type ApiPostDeleteCompanyRequest = {
  company_code: string,
  is_immediate: number,
}
export type ApiEditDeleteCompanyRequest = {
  id: string,
  is_delete: number,
  is_immediate?: number,
}

export type ApiDownloadCsvDeleteCompanyRequest = Pick<
  ApiGetDeleteCompanyRequest,
  'is_view' | 'kind' | 'sort_by' | 'highlow'
>

const deleteCompany = (url: string) => () => {
  return {
    get: (param?: ApiGetDeleteCompanyRequest) =>
      con.get<ResponseBase<ApiGetDeleteCompanyListResponse[], PagerBase & ListType>>( url + path, param ?? {}),
    getDetail: (id: string) =>
      con.get<ResponseBase<ApiGetDeleteCompanyListResponse, PagerBase & ListType>>( url + path + `/${id}`, {}),
    post: (param: ApiPostDeleteCompanyRequest) =>
      con.post( url + path, param),
    edit: (param: ApiEditDeleteCompanyRequest) => {
      const {
        id,
        ...rest
      } = param;
      return con.post( url + path + `/${id}`, {...rest});
    },
    download: (param: ApiDownloadCsvDeleteCompanyRequest) => 
      con.getFile<Blob>( url + path + '/download', param ?? {}),
    downloadLog: (param: {
      extract_date_start?: string,
      extract_date_end?: string,
    }) => 
      con.getFile<Blob>( url + path + '/log-download', param ?? {}),
  }
}

export default deleteCompany;